module.exports = __webpack_public_path__ + "img/wecare-xiaomi-note-8t.a0fd6be0.png";